import React from 'react'

import Marquee from 'sections/Marquee'

import SectionContainer from '@/Section/Container'
import ImagesMosaic from '@/ImagesMosaic'


const Scenarios = ({
  sectionGeneral: { theme },
  sectionHeader,
  sectionContent
}) => (
  <SectionContainer
    theme={theme}
    sectionHeader={sectionHeader}
    footer={
      sectionContent.marquee ?
        <Marquee
          {...sectionContent.marquee}
          theme={theme}
          css={{
            paddingX: 0,
            paddingTop: 0,
            paddingBottom: 56,
            '@md': { paddingBottom: 72 }
          }}
        />
        : null
    }
    css={{ '@md': { paddingBottom: 72 } }}
  >
    <ImagesMosaic items={sectionContent.scenarios} theme={theme}/>
  </SectionContainer>
)

export default Scenarios
